import React from "react";
import './styles.css';

export const InfoRow = ({
    title,
    value,
    unit = '',
}) => {
    const renderedTitle = title ? `${title}:` : '';
    if (!value) {
        return null;
    }

    return (
        <div className="info-row_container">
            <div className="info-row_title">
                {renderedTitle}
            </div>
            <div className="info-row_value">
                {`${value.toLocaleString()} ${unit}`}
            </div>
        </div>
    );
}
